var _line, _path, _ellipse, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFoundicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 179,
    viewBox: "0 0 132 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 67.2721,
    y1: 68.377,
    x2: 67.2721,
    y2: -0.00858305,
    stroke: "url(#paint0_linear_1395_2727)",
    strokeWidth: 0.636145
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9523 74.7384C73.9523 73.0512 73.282 71.4332 72.089 70.2402C70.896 69.0472 69.278 68.377 67.5908 68.377C65.9037 68.377 64.2856 69.0472 63.0926 70.2402C61.8996 71.4332 61.2294 73.0512 61.2294 74.7384L67.5908 74.7384H73.9523Z",
    fill: "url(#paint1_linear_1395_2727)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0361,
    cy: 4.77108,
    rx: 27.0361,
    ry: 4.77108,
    transform: "matrix(-1 0 0 1 94.6259 95.4131)",
    fill: "url(#paint2_angular_1395_2727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.5542 99.999H94.6265L132 178.999H0L40.5542 99.999Z",
    fill: "url(#paint3_linear_1395_2727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6258 100.185C94.6258 93.0142 91.7773 86.1374 86.7071 81.0671C81.6368 75.9969 74.76 73.1484 67.5896 73.1484C60.4192 73.1484 53.5424 75.9969 48.4722 81.0671C43.4019 86.1374 40.5535 93.0141 40.5535 100.185L67.5896 100.185H94.6258Z",
    fill: "url(#paint4_linear_1395_2727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_2727",
    x1: 67.5902,
    y1: 34.1842,
    x2: 68.5902,
    y2: 34.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD5A",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8865BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1395_2727",
    x1: 64.2756,
    y1: 68.8126,
    x2: 75.3344,
    y2: 73.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272019,
    stopColor: "#FFBA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497676,
    stopColor: "#FFE2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854985,
    stopColor: "#F8990B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_1395_2727",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0361 4.77108) rotate(36.6197) scale(23.1615 131.248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1395_2727",
    x1: 66,
    y1: 99.999,
    x2: 66,
    y2: 178.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED18E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246075,
    stopColor: "#FFD99F",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC874",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1395_2727",
    x1: 53.5,
    y1: 75,
    x2: 100.5,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272019,
    stopColor: "#FFBA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497676,
    stopColor: "#FFE2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854985,
    stopColor: "#F8990B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundicon);
export default __webpack_public_path__ + "static/media/notFoundicon.0d0885bd365e83f51b6f2d20d6d31b48.svg";
export { ForwardRef as ReactComponent };